var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.body != null)?_c('div',{staticClass:"lp_page"}):(_vm.isNotFound)?_c('NotFound'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }